<template>
    <div>
        <div class="comment-header">
            <div class="left">
                我来说两句
            </div>
            <div class="right">
                <a class='shine' href='//www.sohu.com/collection/1065' target='_blank' v-if="showShine"/>
                <span class="num-red">{{participationSum}}</span>人参与，
                <span class="num-red">{{outerCmtSum}}</span>条评论
            </div>
        </div>
        <!-- 发布框 -->
        <Publish :showUser="true" :data="meCommentData"/>
        <div class="c-comment-convention">
            <a target="_blank" href="http://zt.pinglun.sohu.com/s2014/sljyhgy/index.shtml">
                搜狐“我来说两句” 用户公约
            </a>
        </div>
    </div>
</template>
<script>
import Publish from './Publish.vue'

export default{
    name: 'meComment',
    components: {
        Publish
    },
    data(){
        return {
            meCommentData: {},
        }
    },
    computed: {
        showShine() {
            return window.pcArticleInfo?.sGrade != 3
        },
        // 参与人数
        participationSum() {
            return this.meCommentData?.participationSum || 0
        },
        // 评论数
        outerCmtSum() {
            return this.meCommentData?.outerCmtSum || 0
        }
    },
    watch: {
        outerCmtSum(_new) {
            const commentListDom = document.querySelector('#commentList')
            if(commentListDom) {
                // 模糊计算“评论流”高度，取底下2者的最小值(评论锚点跳转需要高度撑起) 
                    // 1. 一条评论最小高度是141px，最多展示15条
                    // 2. 屏幕可视高度 - 导航高度
                const minHeight = _new ?
                    Math.min(141 * Math.min(15, _new) + 80, window.innerHeight - 114 - 48)
                    : 0
                commentListDom.style.minHeight = minHeight + 'px'
            }
        }
    },
    mounted() {
        window?.EVENT_BUS?.$on('meCommentData',this.updateMeCommentData)
        window.EVENT_BUS.$on('deleteComment', () => {
            if(this.meCommentData?.outerCmtSum){
                this.meCommentData.outerCmtSum = this.meCommentData?.outerCmtSum - 1
            }
        })
        this.$nextTick(()=>{
            window.sohuSpm?.domDidChange({
                target: 'comment'
            });
        })
    },
    methods: {
        updateMeCommentData(meCommentData) {
            if(this.meCommentData?.topicId) return
            this.meCommentData = meCommentData
        }
    }
}
</script>
<style lang="less" scoped>
.comment-header {
    padding: 11px 0 7px;
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
        font-size: 18px;
        color: #191919;
    }
    .left::before {
        content: '';
        background: #fdd000;
        display: inline-block;
        width: 4px;
        height: 19px;
        margin-right: 7px;
        vertical-align: middle;
        border-radius: 2px;
        margin-top: -4px;
    }
    .right {
        color: #333;
        font-weight: 400;
        position: relative;
        .shine {
            position: absolute;
            bottom: -3px;
            left: -68px;
            width: 66px;
            height: 46px;
            background: url('../../images/pc-sunshine.png');
            background-size: 100% 100%;
        }
        .num-red {
            font-size: 22px;
            font-family: "Georgia Regular", Georgia;
            color: #d92227;
        }
    }
}
.c-comment-convention {
    margin: 12px 0 28px;
    a {
        line-height: 16px;
        font-size: 12px;
        color: #c9c9c9;
    }
    a:hover {
        text-decoration: underline;
    }
}
</style>
